export type TSectionAnchor =
  | '#'
  | 'projects'
  | 'online-purchase'
  | 'pik-standard'
  | 'pik-children'
  | 'about'
  | 'furniture';

export interface INavLinks {
  title: string;
  value: TSectionAnchor;
  offsetTop: number;
  offsetHeight: number;
}

export const sectionsMapper: Record<string, string> = {
  projects: 'Проекты',
  'online-purchase': 'Онлайн покупка',
  furniture: 'ПИК-Мебель',
  'pik-standard': 'ПИК-Стандарт',
  'pik-children': 'ПИК — детям',
  about: 'О компании',
};
